import { Pipe, PipeTransform } from '@angular/core'
import * as R from 'ramda'
import { getCountryByCode } from '../constants'

@Pipe({
  name: 'address',
  standalone: false,
})
export class AddressPipe implements PipeTransform {
  transform(addr: any, ui = false): string {
    if (!addr) {
      return ''
    }
    let { address, city, state, country, cc, zip } = addr
    const postalCode = addr.postalCode || addr.postal_code || zip
    const countryCode = addr.country_code || addr.countryCode || addr.cc
    country = country || getCountryByCode(countryCode || cc)
    const vatTin = addr.vat_tin || addr.vatTin

    if (!ui) {
      return R.filter(
        (i) => !!i,
        [address, city, state, postalCode, country, vatTin ? `VAT/Tax ID: ${vatTin}` : '']
      ).join(', ')
    }

    const statePostalCode = `${state || ''} ${postalCode || ''}`.trim()
    const cityStatePostalCode = city && statePostalCode ? `${city}, ${statePostalCode}` : city || statePostalCode || ''

    return R.filter(
      (i) => !!i,
      [address, `${cityStatePostalCode}`, country, vatTin ? `VAT/Tax ID: ${vatTin}` : '']
    ).join('<br/>')
  }
}
